export const useNumberToAlpha = (num: number, isUpper: boolean = true) => {
  if (num <= 0 || num >= 53 || isNaN(num)) {
    return "";
  }

  let charCode = (isUpper ? 64 : 96) + (num % 26 || 26);
  return String.fromCharCode(charCode);
};
